exports = module.exports = require("../../../../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".page-gift-card-preview.preview-email {\n  display: block;\n}\n.page-gift-card-preview.preview-email p.preview-email__edit {\n  cursor: pointer;\n}", ""]);

// exports
